// Static look of each audit-log action. Values mirror the action strings the API documents
// (prisma/schema.prisma, AuditLog.action). Actions outside this list get UNKNOWN_ACTIVITY_STYLE.

export const ACTIVITY_ACTIONS = ['create', 'update', 'delete', 'approve', 'reject'] as const;
export type ActivityAction = (typeof ACTIVITY_ACTIONS)[number];

export interface ActivityStyle {
  icon: string;
  color: string;
  label: string;
}

export const activityTypeConfig: Record<ActivityAction, ActivityStyle> = {
  create: { icon: 'ri-add-circle-line', color: 'text-teal-400', label: 'Created' },
  update: { icon: 'ri-edit-line', color: 'text-sky-400', label: 'Updated' },
  delete: { icon: 'ri-delete-bin-line', color: 'text-red-400', label: 'Deleted' },
  approve: { icon: 'ri-checkbox-circle-line', color: 'text-green-400', label: 'Approved' },
  reject: { icon: 'ri-close-circle-line', color: 'text-rose-400', label: 'Rejected' },
};

export const UNKNOWN_ACTIVITY_STYLE: ActivityStyle = {
  icon: 'ri-question-line',
  color: 'text-gray-500',
  label: 'Other',
};

export function isActivityAction(value: string): value is ActivityAction {
  return (ACTIVITY_ACTIONS as readonly string[]).includes(value);
}
